import { AfterContentChecked, AfterContentInit, ChangeDetectorRef, Component, ContentChild, ElementRef, EventEmitter, HostListener, Input, OnInit, Optional, Output, TemplateRef } from '@angular/core';
import { ControlContainer, FormGroupDirective, UntypedFormArray, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { interval } from 'rxjs';
import { distinctUntilChanged, filter, finalize, takeWhile, timeout } from 'rxjs/operators';
import { Bank } from 'src/app/modules/dashboard/pages/payment-data/payment-data.component';

@Component({
    selector: 'app-select-report',
    templateUrl: './select-report.component.html',
    styleUrls: ['./select-report.component.scss'],
    viewProviders: [
        {
            provide: ControlContainer,
            useExisting: FormGroupDirective,
        },
    ],
    standalone: false
})
export class SelectReportComponent implements OnInit, AfterContentChecked, AfterContentInit {
	public selectedLabel: string = '';
	public savedBankLabel: Bank = { name: '', code: '' };
	public activeList: boolean = false;
	public openedOnce: boolean = false;
	public itemsToSave: any;
	public itemsState: any;
	public itemsCity: any;
	public itemsBank: any;
	public itemsNotFound: boolean = false;
	public selectedItems: any[] = [];
	public filteredItemsCache: any[] = [];
	public isInFilteredMode: boolean = false;
	public contractPlatesList: any[] = [];
	public isContractFilterActive: boolean = false;
	public temporaryFullList: any[] = [];
	public cascadeFilteredItems: any[] = [];

	@Input() public items!: any;
	@Input() public key!: string;
	@Input() public value!: string;
	@Input() public controlName!: string;
	@Input() public arrayName!: string;
	@Input() public arrayIndex!: number;
	@Input() public customClass: string = '';
	@Input() public placeHolder: string = '';
	@Input() public disabled: boolean = false;
	@Input() public isStandaloneValue: boolean = false;
	@Input() public hasClearButton?: boolean = false;
	@Input() public standaloneValue: any = null;
	@Input() public customTemplate: boolean = false;
	@Input() public item: any = null;
	@Input() public isCiiuLabel: boolean = false;
	@Input() public isState: boolean = false;
	@Input() public isCity: boolean = false;
	@Input() public isBank: boolean = false;
	@Input() public isBanksLoaded!: boolean;
	@Input() public disableSearch: boolean = true;
	@Input() multiple = false;
	@Input() emitObject = false;

	@Output() blurEvent: EventEmitter<void> = new EventEmitter<void>();
	@Output() public changeEvent: EventEmitter<{ label: string; value: string }> = new EventEmitter<{ label: string; value: string }>();

	@ContentChild('header', { static: false }) public headerTemplateRef!: TemplateRef<any>;

	constructor(
		@Optional() private controlContainer: ControlContainer,
		private _cd: ChangeDetectorRef,
		private elementRef: ElementRef
	) {}

	ngOnInit(): void {
		if (!this.isStandaloneValue && !this.isBank) {
			this.control?.valueChanges.pipe(distinctUntilChanged()).subscribe((value: any) => {
				if (this.multiple) {
					if (Array.isArray(value)) {
						this.selectedItems = this.items?.filter((item: any) => value.includes(item[this.key])) || [];
						this.selectedLabel = this.selectedItems.map(i => this.getValue(i)).join(', ');
					}
				} else {
					if (value == null) {
						this.selectedLabel = '';
					} else {
						const matchedItem = this.items?.find((item: any) => item[this.key] === value);
						if (matchedItem) {
							this.select(matchedItem);
						}
					}
				}

				this.changeEvent.emit({ label: this.selectedLabel, value: value });
				this._cd.detectChanges();
			});
		}
	}

	ngAfterContentInit(): void {
		if (this.isBank) {
			this.waitForBankItemsLoaded();
		}
		setTimeout(() => {
			this.itemsState = this.items;
			this.itemsCity = this.items;
			this.itemsToSave = this.items;
			this.temporaryFullList = [...(this.items || [])];
			this._cd.markForCheck();
		}, 1000);
	}

	get isBankContextLoaded(): boolean {
		return this.isBank && this.isBanksLoaded;
	}

	private waitForBankItemsLoaded(timeoutDuration = 10000, intervalDuration = 500): void {
		interval(intervalDuration)
			.pipe(
				filter(() => this.isBankContextLoaded),
				takeWhile(() => !this.isBankContextLoaded, true),
				timeout(timeoutDuration),
				finalize(() => {
					if (!this.isBankContextLoaded) {
						console.error('Timeout: os bancos não foram carregados a tempo.');
					}
				})
			)
			.subscribe({
				next: () => this.initializeItems(),
				error: err => console.error(err.message),
			});
	}

setContractPlates(plates: any[]): void {
  if (!this.isContractFilterActive || plates.length > this.contractPlatesList.length) {
    this.contractPlatesList = [...plates];
    this.isContractFilterActive = true;
  } else {
    return;
  }

  this.items = [...plates];
  this.itemsToSave = [...plates];
}
clearContractFilter(): void {
  this.contractPlatesList = [];
  this.isContractFilterActive = false;

  if (this.temporaryFullList.length > 0) {
    this.items = [...this.temporaryFullList];
    this.itemsToSave = [...this.temporaryFullList];
  }
}
clearSelection(): void {
  if (this.isStandaloneValue) {
    this.selectedLabel = '';
    this.changeEvent.emit({ label: '', value: '' });
  } else {
    if (this.multiple) {
      this.selectedItems = [];
      this.selectedLabel = '';
      this.control.setValue([], { emitEvent: true });
    } else {
      const currentValue = this.control.value;
      this.selectedLabel = '';
      if (currentValue != null) {
        this.control.setValue(null, { emitEvent: true });
      } else {
        this.control.setValue(null, { emitEvent: false });
      }
    }
  }

  this.itemsNotFound = false;
  this.activeList = false;
  if (this.isContractFilterActive && this.contractPlatesList.length > 0) {
    this.items = [...this.contractPlatesList];
  } else if (this.temporaryFullList.length > 0) {
    this.items = [...this.temporaryFullList];
    this.itemsToSave = [...this.temporaryFullList];
  } else if (this.isInFilteredMode && this.filteredItemsCache.length > 0) {
    this.items = [...this.filteredItemsCache];
  }

  this._cd.detectChanges();
}

	initializeItems(): void {
		this.itemsBank = this.items;
		this._cd.markForCheck();
	}

	ngAfterContentChecked(): void {
		if (this.items && this.selectedLabel == '' && !this.isStandaloneValue && !this.isBank) {
			const selectedValue = this.control?.value;
			let matchedItem = this.items?.find((item: any) => item[this.key] === selectedValue);
			if (!matchedItem) {
				matchedItem = this.items?.find((item: any) => item[this.key] == selectedValue);
			}
			if (matchedItem) {
				this.select(matchedItem);
			}
		}
	}

	ngOnChanges() {
		if (this.isStandaloneValue && this.standaloneValue == null) {
			this.selectedLabel = '';
		}
		this.itemsCity = this.items;
		this.itemsToSave = [...(this.items || [])];
		this.temporaryFullList = [...(this.items || [])];
	}

	onBlur() {
		this.control?.markAsTouched();
		this.blurEvent.emit();
	}

	setFilteredItems(items: any[]): void {
  this.cascadeFilteredItems = [...items];
  this.filteredItemsCache = [...items];
  this.isInFilteredMode = true;
  this.items = [...items];
  this.itemsToSave = [...items];
  if (this.temporaryFullList.length === 0) {
    this.temporaryFullList = [...items];
  }
}

	clearFilteredCache(): void {
	this.cascadeFilteredItems = [];
	this.filteredItemsCache = [];
	this.isInFilteredMode = false;
	if (this.temporaryFullList.length > 0) {
		this.items = [...this.temporaryFullList];
		this.itemsToSave = [...this.temporaryFullList];
	}
}
restoreFromCascadeFilter(): void {
	if (this.cascadeFilteredItems.length > 0) {
		this.items = [...this.cascadeFilteredItems];
		this.itemsToSave = [...this.cascadeFilteredItems];
		this.filteredItemsCache = [...this.cascadeFilteredItems];
		this.isInFilteredMode = true;
	}
}

	updateTemporaryFullList(items: any[]): void {
		this.temporaryFullList = [...items];
	}

	restoreFromTemporaryFullList(): void {
		if (this.temporaryFullList.length > 0) {
			this.items = [...this.temporaryFullList];
			this.itemsToSave = [...this.temporaryFullList];
			this.isInFilteredMode = false;
			this.filteredItemsCache = [];
		}
	}



filterValue(event: any): void {
  const searchValue = event.value?.toLowerCase() || '';
  this.activeList = true;

  if (searchValue === '') {
    this.selectedLabel = '';
    if (!this.isStandaloneValue && this.control) {
      this.control.setValue(null, { emitEvent: true });
    }
    if (this.isStandaloneValue) {
      this.changeEvent.emit({ label: '', value: '' });
    }
    if (this.isContractFilterActive && this.contractPlatesList.length > 0) {
      this.items = [...this.contractPlatesList];
    } else if (this.isInFilteredMode && this.filteredItemsCache.length > 0) {
      this.items = [...this.filteredItemsCache];
    } else if (this.temporaryFullList.length > 0) {
      this.items = [...this.temporaryFullList];
    } else {
      this.items = [...(this.itemsToSave || [])];
    }
    this.itemsNotFound = false;
    return;
  }
  let itemsToFilter: any[];
  let filterContext = '';

  if (this.isContractFilterActive && this.contractPlatesList.length > 0) {
    itemsToFilter = this.contractPlatesList;
    filterContext = 'contrato';
  } else if (this.isInFilteredMode && this.filteredItemsCache.length > 0) {
    itemsToFilter = this.filteredItemsCache;
    filterContext = 'filtrado general';
  } else if (this.temporaryFullList.length > 0) {
    itemsToFilter = this.temporaryFullList;
    filterContext = 'lista completa';
  } else {
    itemsToFilter = this.itemsToSave || [];
    filterContext = 'lista original';
  }

  const filteredItems = [];
  for (const item of itemsToFilter) {
    if (this.matchesSearch(item, searchValue)) {
      filteredItems.push(item);
    }
  }

  this.items = filteredItems;
  this.itemsNotFound = this.items.length === 0;
  if (!this.isContractFilterActive && !this.isInFilteredMode && this.selectedLabel && !this.items.some((item: any) => this.buildLabel(item).toLowerCase().includes(searchValue))) {
    this.selectedLabel = '';
    if (!this.isStandaloneValue && this.control) {
      this.control.setValue(null, { emitEvent: false });
    }
  }
}

	getItemsToFilter(): any[] {
		return this.items || [];
	}
matchesSearch(item: any, searchValue: string): boolean {
  const searchLower = searchValue.toLowerCase();

  const includesSearchValue = (field: string | undefined): boolean =>
    (field?.toLowerCase() || '').includes(searchLower);

  // Para etiquetas CIIU
  if (this.isCiiuLabel) {
    const fieldsToCheck = new Set([
      item?.code,
      item?.description,
      `${item?.code} - ${item?.description}`
    ]);

    for (let field of fieldsToCheck) {
      if (includesSearchValue(field)) {
        return true;
      }
    }
    return false;
  }

  const fieldsToSearch = [
    item?.name,
    item?.order,
    item?.plate,
    item?.city,
    typeof item === 'string' ? item : null,
    item?.value,
    item?.label
  ];
  return fieldsToSearch.some(includesSearchValue);
}

	get form(): UntypedFormGroup {
		return this.controlContainer.control as UntypedFormGroup;
	}

	get control(): UntypedFormControl {
		if (this.arrayName) {
			const formArray = this.form.get(this.arrayName) as UntypedFormArray;
			return formArray.controls[this.arrayIndex].get(this.controlName) as UntypedFormControl;
		}
		return this.form.get(this.controlName) as UntypedFormControl;
	}

	public getValue(item: any): any {
		return item[this.value];
	}

select(item: any): void {
  if (!item) return;

  this.savedBankLabel = item;
  this.selectedLabel = this.buildLabel(item);

  if (!this.isStandaloneValue) {
    this.control.setValue(item[this.key], { onlySelf: !!this.arrayName });
  }

  if (this.isStandaloneValue) {
    this.changeEvent.emit({ label: this.selectedLabel, value: item });
  }
  this.activeList = false;
  this._cd.detectChanges();
  if (this.isInFilteredMode && this.filteredItemsCache.length > 0) {
    this.applyFilterSilently(this.selectedLabel, true);
  } else {
    this.applyFilterSilently(this.selectedLabel, true);
  }
}

applyFilterSilently(searchValue: string, keepSelection: boolean = true): void {
  const searchValueLower = (searchValue || '').toLowerCase();

  if (searchValueLower === '') {
    if (this.isContractFilterActive && this.contractPlatesList.length > 0) {
      this.items = [...this.contractPlatesList];
    } else if (this.isInFilteredMode && this.filteredItemsCache.length > 0) {
      this.items = [...this.filteredItemsCache];
    } else if (this.temporaryFullList.length > 0) {
      this.items = [...this.temporaryFullList];
    } else {
      this.items = [...(this.itemsToSave || [])];
    }

    this.itemsNotFound = false;

    if (!keepSelection) {
      this.selectedLabel = '';
      if (!this.isStandaloneValue && this.control) {
        this.control.setValue(null, { emitEvent: true });
      }
    }
    return;
  }
  let itemsToFilter: any[] = [];
  if (this.isContractFilterActive && this.contractPlatesList.length > 0) {
    itemsToFilter = this.contractPlatesList;
  } else if (this.isInFilteredMode && this.filteredItemsCache.length > 0) {
    itemsToFilter = this.filteredItemsCache;
  } else if (this.temporaryFullList.length > 0) {
    itemsToFilter = this.temporaryFullList;
  } else {
    itemsToFilter = this.itemsToSave || [];
  }

  const filteredItems = [];
  for (const item of itemsToFilter) {
    if (this.matchesSearch(item, searchValueLower)) {
      filteredItems.push(item);
    }
  }

  this.items = filteredItems;
  this.itemsNotFound = this.items.length === 0;

  if (
    !keepSelection &&
    this.selectedLabel &&
    !this.items.some((it: any) =>
      this.buildLabel(it).toLowerCase().includes(searchValueLower)
    )
  ) {
    this.selectedLabel = '';
    if (!this.isStandaloneValue && this.control) {
      this.control.setValue(null, { emitEvent: false });
    }
  }
}



onInputClick(): void {
  this.activeList = !this.activeList;
  this.openedOnce = true;

  if (this.selectedLabel) {

    this.applyFilterSilently(this.selectedLabel, true);
  } else {
    if (this.isContractFilterActive && this.contractPlatesList.length > 0) {
      this.items = [...this.contractPlatesList];
    } else if (this.isInFilteredMode && this.filteredItemsCache.length > 0) {
      this.items = [...this.filteredItemsCache];
    } else if (this.temporaryFullList.length > 0) {
      this.items = [...this.temporaryFullList];
    } else {
      this.items = [...(this.itemsToSave || [])];
    }
    this.itemsNotFound = false;
  }

  this._cd.detectChanges();
}


	private buildLabel(item: any): string {
		if (this.isCiiuLabel) {
			const label = `${item[this.value]} - ${item.description}`;
			return label.length > 50 ? label.slice(0, 50) + '...' : label;
		}
		return item[this.value];
	}

	public isDescendant(parent: any, child: { parentNode: any }): boolean {
		let node = child.parentNode;
		while (node != null) {
			if (node == parent) {
				return true;
			}
			node = node.parentNode;
		}
		return false;
	}

	@HostListener('document:click', ['$event'])
	public clickout(event: any): void {
		const customList = this.elementRef.nativeElement.querySelector('.custom-select-list');
		if (this.activeList && !this.isDescendant(customList, event.target) && !event.target.classList.contains('custom-select-input')) {
			this.activeList = false;
		}
	}

	toggleSelection(item: any): void {
		if (!this.multiple) {
			this.select(item);
			this.activeList = false;
			return;
		}

		const index = this.selectedItems.findIndex(i => i[this.key] === item[this.key]);
		if (index > -1) {
			this.selectedItems.splice(index, 1);
		} else {
			this.selectedItems.push(item);
		}

		this.updateControlValue();
	}
	isSelected(item: any): boolean {
		return this.selectedItems.some(i => i[this.key] === item[this.key]);
	}

	updateControlValue(): void {
		const value = this.selectedItems.map(i => i[this.key]);
		this.control?.setValue(value);
		this.selectedLabel = this.selectedItems.map(i => this.getValue(i)).join(', ');
	}
}
